import React from "react";
import {
  Edit,
  DateInput,
  TextInput,
  SimpleForm,
  NumberInput,
  useNotify,
  useRefresh,
} from "react-admin";
import { parse } from "query-string";

import { makeStyles } from "@material-ui/core/styles";

import { MyEditActions } from "../__common/MyEditActions";
import { AutoCompleteCultureCode } from "./AutoCompleteCultureCode";

const useEditStyles = makeStyles({
  root: { alignItems: "flex-start" },
});

export const CultureEdit = (props) => {
  const { id_sample: id_sample_string } = parse(props.location.search);

  const id_sample = id_sample_string ? parseInt(id_sample_string, 10) : "";

  const redirect = id_sample_string
    ? `/samples/${id_sample}/show/cultures`
    : false;

  const classes = useEditStyles();

  const notify = useNotify();
  const refresh = useRefresh();

  const onSuccess = () => {
    notify(`Changes saved`);
    refresh();
  };

  return (
    <Edit
      title="Edit Culture"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyEditActions />}
      {...props}
      classes={classes}
    >
      <SimpleForm initialValues={{ id_sample }} redirect={redirect}>
        <AutoCompleteCultureCode></AutoCompleteCultureCode>
        <TextInput source="atmosphere" />

        <NumberInput source="num_isolates" />

        <NumberInput source="temperature" />

        <DateInput
          source="culture_date"
          locales="es-UY"
          options={{ timeZone: "UTC" }}
        />

        <TextInput
          fullWidth
          source="notes"
          label="Notes"
          multiline
          minRows={6}
        />
      </SimpleForm>
    </Edit>
  );
};
